var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EnvironmentContext } from './environment-context';
import { useEnvironment } from './hook';
export var EnvironmentName = function (_a) {
    var children = _a.children, name = _a.name;
    var environment = useEnvironment();
    return (_jsx(EnvironmentContext.Provider, __assign({ value: { environmentName: "".concat(environment, "_").concat(name) } }, { children: typeof children === 'function' ? children(environment) : children })));
};
